import { InputHTMLAttributes, useState } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { FiEye, FiEyeOff } from 'react-icons/fi';

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'value' | 'type'> {
  label?: string;
  value?: string;
}

export function PasswordInput({ label, className, ...props }: PasswordInputProps) {
  const [visivel, setVisivel] = useState(false);

  return (
    <Form.Group className="mb-3">
      {label && <Form.Label className="lizzi-form-label">{label}</Form.Label>}
      <InputGroup>
        <Form.Control className={['lizzi-form-control', className].filter(Boolean).join(' ')} type={visivel ? 'text' : 'password'} {...props} />
        <InputGroup.Text
          className="lizzi-password-toggle"
          role="button"
          onClick={() => setVisivel((atual) => !atual)}
          aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        >
          {visivel ? <FiEyeOff size={18} /> : <FiEye size={18} />}
        </InputGroup.Text>
      </InputGroup>
    </Form.Group>
  );
}
